import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { usePresetContext } from "../PresetProvider";

export function PresetSelect() {
  const { t } = useTranslation();
  const { presets, selectedPreset, setSelectedPreset } = usePresetContext();

  return (
    <Autocomplete
      id="preset-search"
      size="small"
      onChange={(_, value) => setSelectedPreset(value)}
      sx={{ width: "100%" }}
      options={presets}
      value={selectedPreset}
      getOptionLabel={option => option.description ?? ""}
      filterOptions={o => o}
      filterSelectedOptions
      disableCloseOnSelect
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {option.description}
          </li>
        );
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => (
        <TextField
          {...params}
          label={t("faultOverview.presetSearch")}
          placeholder={t("faultOverview.presetPlaceholder")}
        />
      )}
    />
  );
}
